import PropTypes from 'prop-types';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import Sidebar from 'components/Sidebar';
import SidebarDescription from 'components/Sidebar/ForumSidebarDescription';
import SidebarRules from 'components/Sidebar/SidebarRules';
import TopContributorsCommentsRanking from 'components/TopContributorsCommentsRanking';

const ForumSidebar = ({ className, gaEventCategory, ...rest }) => {
  const sidebarDescriptionRef = useRef(null);
  const sidebarRulesRef = useRef(null);
  const topContributorsRanking = useRef(null);

  return (
    <Sidebar
      className={twMerge('space-y-4', className)}
      refsToBeIgnoredBeforeFixing={[
        sidebarDescriptionRef,
        sidebarRulesRef,
        topContributorsRanking,
      ]}
      {...rest}
    >
      <SidebarDescription
        ref={sidebarDescriptionRef}
        gaEventCategory={gaEventCategory}
      />
      <SidebarRules ref={sidebarRulesRef} />
      <TopContributorsCommentsRanking
        ref={topContributorsRanking}
        commentsSourceName="threads"
        gaEventCategory={`${gaEventCategory}_contributors`}
      />
    </Sidebar>
  );
};

ForumSidebar.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
};

export default ForumSidebar;
